<template>
    <div>
        <div v-if="data">
            <div v-if="type==='舆情'">
                <div v-for="event in data.content" :key="event.id" class="yq-company-monitor-news">
                    <div class="yq-company-monitor-news-headline">
                        <div class="yq-company-monitor-news-title" @click="openEventPage(event)">{{event.summary.title}}</div>
                    </div>
                    <div class="yq-company-monitor-news-fields">
                        <div class="yq-company-monitor-news-company">相关公司：{{event.companyName}}</div>
                        <div class="yq-company-monitor-news-date">{{event.publishDate}}</div>
                        <div class="yq-company-monitor-news-site">来自：{{event.summary.site}}</div>
                    </div>
                </div>
            </div>
            <el-table v-else-if="type==='工商变更'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="变更事项">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.changeMatter}}</el-link>
                </el-table-column>
                <el-table-column
                        label="变更前内容">
                    <span slot-scope="scope">{{scope.row.summary.changeBefore}}</span>
                </el-table-column>
                <el-table-column
                        label="变更后内容">
                    <span slot-scope="scope">{{scope.row.summary.changeAfter}}</span>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="变更时间" width="120">
                </el-table-column>
            </el-table>
            <el-table v-else-if="type==='行政处罚'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="公告标题">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.docTitle}}</el-link>
                </el-table-column>
                <el-table-column
                        label="处罚机关">
                    <span slot-scope="scope">{{scope.row.summary.mechanism}}</span>
                </el-table-column>
                <el-table-column
                        label="处罚文号">
                    <span slot-scope="scope">{{scope.row.summary.docNo}}</span>
                </el-table-column>
                <el-table-column
                        label="处罚类型">
                    <span slot-scope="scope">{{scope.row.summary.types}}</span>
                </el-table-column>
                <el-table-column
                        label="处罚日期" width="120">
                    <span slot-scope="scope">{{scope.row.summary.penaltyDate}}</span>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="公告日期" width="120">
                </el-table-column>
            </el-table>
            <el-table v-else-if="type==='裁判文书'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="文书名">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.wenshuming}}</el-link>
                </el-table-column>
                <el-table-column
                        label="文书号">
                    <span slot-scope="scope">{{scope.row.summary.wenshuhao}}</span>
                </el-table-column>
                <el-table-column
                        label="案件类型">
                    <span slot-scope="scope">{{scope.row.summary.type}}</span>
                </el-table-column>
                <el-table-column
                        label="所在城市">
                    <span slot-scope="scope">{{scope.row.summary.city}}</span>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="公告日期" width="120">
                </el-table-column>
            </el-table>
            <el-table v-else-if="type==='开庭公告'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="法院名称">
                    <span slot-scope="scope">{{scope.row.summary.courtName}}</span>
                </el-table-column>
                <el-table-column
                        label="公告标题">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.title}}</el-link>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="公告日期" width="120">
                </el-table-column>
            </el-table>
            <el-table v-else-if="type==='失信人'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="案号">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.caseCode}}</el-link>
                </el-table-column>
                <el-table-column
                        label="履行状态">
                    <span slot-scope="scope">{{scope.row.summary.performance}}</span>
                </el-table-column>
                <el-table-column
                        label="执行依据">
                    <span slot-scope="scope">{{scope.row.summary.gistCid}}</span>
                </el-table-column>
                <el-table-column
                        label="执行法院">
                    <span slot-scope="scope">{{scope.row.summary.courtName}}</span>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="公告日期" width="120">
                </el-table-column>
            </el-table>
            <el-table v-else-if="type==='资产负债率过高'" :key="type" class="yq-table" :data="data.content" style="width: 100%">
                <el-table-column
                        label="序号"
                        type="index"
                        :index="indexMethod" width="60">
                </el-table-column>
                <el-table-column
                        prop="companyName"
                        label="公司名称">
                    <el-link slot-scope="scope" @click="openCompanyPage(scope.row.companyId)" type="primary">{{scope.row.companyName}}</el-link>
                </el-table-column>
                <el-table-column
                        label="资产负债率">
                    <el-link slot-scope="scope" @click="openEventPage(scope.row)" type="primary">{{scope.row.summary.zcfzl}}</el-link>
                </el-table-column>
                <el-table-column
                        prop="publishDate"
                        label="公告日期" width="120">
                </el-table-column>
            </el-table>
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import companyMonitorService from '../../service/company_monitor'

    export default {
        name: "CompanyRiskEvents",
        props: {
            searchParams: Object,
            type: String
        },
        data(){
            return {
                data: null
            }
        },
        watch:{
            searchParams:{
                handler(){
                    this.init()
                },
                deep: true
            },
            type(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                await this.fetchData(1)
            },
            async fetchData(page) {
                const params = Object.assign({page: page - 1, size: 10, type: this.type},this.searchParams)
                const response = await companyMonitorService.listCompanyRiskEvents(params)
                this.data = response.data.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            openEventPage(event) {
                companyMonitorService.openEventPage(event)
            },
            openCompanyPage(id) {
                companyMonitorService.openCompanyPage(id)
            }
        }
    }
</script>

<style scoped>

</style>
